<template>
    <div class="order-item-comments">
        <v-card class="maxw600" outlined>
            <v-card-title class="page-heading primary minh60">
                <v-row align="center">
                    <v-col cols="12">{{ $t('order_item_comments.heading') }}</v-col>
                </v-row>
            </v-card-title>

            <v-card-text class="card-body">
                <div class="order-item-comments-header">
                    <v-text-field
                        v-model="commentToAdd"
                        outlined
                        hide-details
                        :label="$t('order_item_comments.enter_name')"
                        single-line
                        autofocus
                        clearable
                        clear-icon="fal fa-times"
                        autocomplete="off"
                        class="comment"
                        @keyup.enter="addComment()"
                    />

                    <v-btn color="primary" text class="minw100 button" :disabled="!commentToAdd" @click="addComment()">
                        <v-icon left>fal fa-plus</v-icon>
                        {{ $t('general.add') }}
                    </v-btn>
                </div>

                <v-data-table
                    class="operations striped"
                    :headers="headers"
                    :items="comments"
                    :mobile-breakpoint="0"
                    hide-default-footer
                >
                    <template slot="item" slot-scope="props">
                        <tr>
                            <td>{{ props.item.comment }}</td>
                            <td align="center" class="w35 maxw60">
                                <v-btn class="error--text" icon @click="deleteComment(props.item)">
                                    <v-icon>fal fa-times</v-icon>
                                </v-btn>
                            </td>
                        </tr>
                    </template>
                </v-data-table>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
import { loadData } from '@/views/shared/loadPageData';
import ApiService from '@/services/ApiService';

export default {
    created() {
        loadData('/admin/load/order-item-comments').then(data => this.onDataLoaded(data));
    },

    data() {
        return {
            comments: [],
            commentToAdd: null,

            headers: [
                { text: this.$t('general.comment'), value: 'comment' },
                { text: this.$t('general.delete'), sortable: false }
            ]
        };
    },

    methods: {
        // Place loaded data into adequate variables
        onDataLoaded(data) {
            this.comments = data.orderItemComments;
        },

        // Add a comment to the list
        addComment() {
            if (!this.commentToAdd) {
                return false;
            }

            ApiService.post('/admin/orderItemComments', { comment: this.commentToAdd })
                .then(response => {
                    this.commentToAdd = null;
                    this.comments.push(response.data);
                    this.$snackbar(this.$t('order_item_comments.saved'), 'success');
                })
                .catch(error => {
                    if (error.response.data.errors.comment[0] === 'The comment has already been taken.') {
                        this.$snackbar(this.$t('order_item_comments.already_on_the_list'), 'error');
                    }
                });
        },

        // Delete a comment from the list
        deleteComment(comment) {
            this.$confirm(
                this.$t('order_item_comments.permanently_delete'),
                {
                    buttonTrueText: this.$t('general.confirm'),
                    icon: 'fal fa-times',
                    color: 'error',
                    title: this.$t('general.delete')
                },
                result => {
                    if (!result) return;

                    ApiService.delete(`/admin/orderItemComments/${comment.id}`, {}).then(response => {
                        this.comments = this.comments.filter(item => item.id !== comment.id);
                        this.$snackbar(this.$t('order_item_comments.deleted'), 'success');
                    });
                }
            );
        }
    }
};
</script>

<style lang="scss" scoped>
.order-item-comments {
    .maxw600 {
        max-width: 600px;
    }

    .page-heading {
        padding: 12px 16px;
        color: white;
        font-size: 16px;
        word-break: break-word;
    }

    .card-body {
        margin-top: 16px;

        .order-item-comments-header {
            display: flex;
            align-items: center;
            margin-bottom: 20px;

            .comment {
                padding-bottom: 5px;
                height: 50px;
                @media screen and (min-width: 600px) {
                    max-width: 450px;
                }
            }

            .button {
                margin-left: 10px;
                margin-top: 5px;
                height: 50px;
            }
        }
    }
}
</style>
